import React from 'react';
import { bool, string, shape } from 'prop-types';
import Product from 'components/Product';
import styles from './styles';

function ProductTeaser(props) {
  const { titleHtml, product, isAffiliate, isAmp } = props;

  if (!product) {
    return null;
  }

  return (
    <div className="ProductTeaser">
      {titleHtml && (
        <div
          className="ProductTeaser__heading"
          dangerouslySetInnerHTML={{ __html: titleHtml }}
        />
      )}

      <Product isAffiliate={isAffiliate} isAmp={isAmp} {...product} />

      <style jsx>{styles}</style>
    </div>
  );
}

ProductTeaser.propTypes = {
  titleHtml: string,
  product: shape(),
  isAffiliate: bool.isRequired,
  isAmp: bool.isRequired
};

ProductTeaser.defaultProps = {
  titleHtml: undefined,
  product: undefined
};

export default ProductTeaser;
